import { useNavigation } from '@react-navigation/native'
import React, { useState } from 'react'

import { DescriptionInput } from 'pages/CoachOnboarding/subcomponents/DescriptionInput'

import { BottomSheetNav } from 'widgets/BottomSheetNav'
import { Box } from 'widgets/Box'

import { useCurrentUser } from 'hooks/useCurrentUser'
import { useGroup } from 'hooks/useGroup'

import { links } from 'utils/constants'

export const UpspaceDescriptionPage = () => {
  const navigation = useNavigation<any>()
  const { data: currentUser } = useCurrentUser()
  const { data: group, updateGroup } = useGroup({ userId: currentUser?.id })

  const [description, setDescription] = useState<string | null>()

  const handleNextPress = () => {
    if (group) {
      updateGroup.mutate({
        ...group,
        bio: description?.trim() ?? '',
      })
    }
    navigation.navigate(links.UPSPACE_IMAGE_PAGE)
  }

  const handleSkip = () => {
    if (group) {
      updateGroup.mutate({
        ...group,
        bio: '',
      })
    }
    navigation.navigate(links.UPSPACE_IMAGE_PAGE)
  }

  return (
    <Box flex={1} testID='UpspaceDescriptionPage' backgroundColor='v2primary'>
      <BottomSheetNav withBack withNext onNextPress={handleSkip} />
      <DescriptionInput
        input={description}
        setInput={setDescription}
        promptTitle='Write a bio explaining the concept and goals of your Group'
        inputPlaceholder='Description / Bio'
        onNext={handleNextPress}
      />
    </Box>
  )
}
